import React, { FC } from 'react';
import { MixpanelEvents } from 'integrations/mixpanel/Events/MixpanelEvents';
import { useMixpanel } from 'integrations/mixpanel/useMixpanel';
import { ExportEventDetails } from 'integrations/mixpanel/Events/general';
import { DataTablePluginExporter } from '@utmost.co/utmost-design-system';
import { useExportsTo } from 'src/utils/hooks/data/exports/useExportsTo';
import { ExportSource } from 'src/utils/hooks/data/exports/utils/Exports.types';
import { JobFamilyQueryModelInput, OcCsvExportQueryModelInput } from 'src/graphql/types';
import { useJobCataloguesIntl } from '@oc/pages/settings/Engagements/JobCatalogues/translations/useJobCataloguesIntl';

type JobFamilyFilterModel = Omit<Partial<JobFamilyQueryModelInput>, 'search'> & { search?: string };

export const JobFamiliesExporter: FC = () => {
  const { track } = useMixpanel();
  const intl = useJobCataloguesIntl();
  const exportJobFamilies = useExportsTo();

  return (
    <DataTablePluginExporter<JobFamilyFilterModel>
      exportFileFormats={['CSV', 'XLSX']}
      onExport={(quickReport, fileFormat, source, quickReportName) => {
        const mode = fileFormat === 'CSV' ? 'batch-csv' : 'batch-excel';
        track<ExportEventDetails>(MixpanelEvents.general.EXPORT, {
          exportType: mode,
          exportEntity: 'job_family',
          origin: source ?? 'unknown'
        });
        exportJobFamilies({
          query: { jobFamilies: {} as OcCsvExportQueryModelInput['jobFamilies'] },
          mode,
          reportName: intl.jobFamilies,
          source: ExportSource.JobFamilies
        });
      }}
      onOpen={() => {
        track(MixpanelEvents.quickReport.CHIP_OPEN_EXPORT_MENU_CLICK, { view: 'Job Families' });
      }}
    />
  );
};
